/* Message sort options */
export enum MessageSortMenuItem {
  NEWEST = 'newest',
  MOST_LIKED = 'mostLiked',
  MOST_VIEWED = 'mostViewed',
  MOST_RELEVANT = 'mostRelevant'
}

/* Last update filter options */
export enum LastUpdateFilterMenuItem {
  PAST_DAY = 'pastDay',
  PAST_WEEK = 'pastWeek',
  PAST_MONTH = 'pastMonth',
  PAST_YEAR = 'pastYear'
}

/* Replies filter options */
export enum RepliesFilterMenuItem {
  WITH_SOLUTION = 'withSolution'
}

/* Search Item Type */
export enum SearchItemType {
  USER = 'UserSearchResult',
  MESSAGE = 'QuickMessageSearchResult',
  NODE = 'NodeSearchResult',
  FOLLOW = 'Follow'
}
